import { render, staticRenderFns } from "./lt-label.vue?vue&type=template&id=f635629a&scoped=true"
import script from "./lt-label.vue?vue&type=script&lang=js"
export * from "./lt-label.vue?vue&type=script&lang=js"
import style0 from "./lt-label.vue?vue&type=style&index=0&id=f635629a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f635629a",
  null
  
)

export default component.exports